export const MY_USER_NAME = 'Jonny Wolfson';

export const getMyUser = () => ({
  login: MY_USER_NAME,
  id: '1234',
  avatar_url: 'https://avatars.githubusercontent.com/u/28542518?v=4',
  html_url: 'https://github.com/JonnyAdaptableTools',
});

export const allUserNames = [
  'Sarah Williams',
  'Nicole Miller',
  'Amanda Moore',
  'Ashley Brown',
  'Avni Lopez',
  'Curtis Cabrera',
  'Eathan Howarth',
  'Ayrton Goff',
  'Kamil Powers',
  'Layla-Rose Prosser',
  'Vienna Villarreal',
  'Regina Dodd',
  'Billie-Jo Delaney',
  'Courteney Brandt',
];
